import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ DetailwarehouseData }) => {
    const accountOptions = [
        { name: 'Test Account 1' },
        { name: 'Test Account 2' },
        { name: 'Test Account 3' },
    ];

    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Checkbox
                                        id="isRejectedWarehouse"
                                        label="is RejectedWarehouse"
                                        checked={!!DetailwarehouseData?.is_rejected_warehouse}
                                        
                                        disabled={true}
                                    />
                                    <div style={{ fontSize: "9px", color: "#00000099", marginLeft: '23px' }}>
                                        If yes, then this warehouse will be used to store rejected materials
                                    </div>

                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Bin Name"
                                        label="Bin Name"
                                        style={{ height: "30px" }}
                                        value={DetailwarehouseData?.warehouse_name || ''}
                                        
                                        readOnly
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="ParentWarehouse"
                                        label="Parent Warehouse"
                                        style={{ height: "30px" }}
                                        value={DetailwarehouseData?.parent_warehouse || ''} 
                                        readOnly
                                    />
                                   
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1, height:'24px' }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}></p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                     <Input
                                        id="Company"
                                        label="Company"
                                        style={{ height: "30px" }}
                                       value={DetailwarehouseData?.company || ''}
                                        readOnly
                                    />
                                    
                                </div>

                                <div style={{ flex: 1 }}>
                                     <Input
                                        id="Account"
                                        label="Account"
                                        style={{ height: "30px" }}
                                       value={DetailwarehouseData?.account || ''}
                                        readOnly
                                    />
                                   

                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Abbr"
                                        label="Abbr"
                                        style={{ height: "30px" }}
                                         value={DetailwarehouseData?.abbr || ''}
                                        readOnly
                                    />
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Tab1;